<template>
  <div class="content background1">
    <div class="pageTitle"><p>设备管理</p></div>
    <div class="chooseBoxMin">
      <div class="chooseBox">
        <div class="selectBox">
          <div>
            <div class="selectChoose">
              <div class="selectText"><p>设备编号</p></div>
              <div class="select">
                <el-input v-model="searchDataList.deviceCode"
                          placeholder="请输入设备编号"></el-input>
              </div>
            </div>
          </div>
          <div>
            <div class="selectChoose">
              <div class="selectText"><p>设备名称</p></div>
              <div class="select">
                <el-input v-model="searchDataList.deviceName"
                          placeholder="请输入设备名称"></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="buttonBox">
          <!--          <div>-->
          <!--			<excel-export :sheet="sheet" :filename="excelName">-->
          <!--				<div class="chooseButton exportButton"><i class="el-icon-download"></i>导出</div>-->
          <!--			</excel-export>-->
          <!--          </div>-->
          <div>
            <div class="chooseButton searchButton" @click="search"><i class="el-icon-search"></i>查询</div>
          </div>
        </div>
      </div>
    </div>
    <div class="tableBox">
      <div class="tableMes">
        <div class="table">
          <div class="btnBox2">
            <div class="editButton" @click="update" v-if="MenuRoleList.indexOf('A311')>=0"><i class="el-icon-edit"></i>{{ $t('btn_15') }}
            </div>
          </div>
          <el-table
            :data="tableData"
            highlight-current-row
            @current-change="handleCurrentChange"
            border
            style="width: 100%;"
            :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
            <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex" width="50">
            </el-table-column>
            <el-table-column
              prop="code"
              label="设备编号" align="center">
            </el-table-column>
            <el-table-column
              prop="name"
              label="设备名称" align="center">
            </el-table-column>
            <el-table-column
              prop="brand"
              label="设备品牌" align="center">
            </el-table-column>
            <el-table-column
              prop="model"
              label="设备型号" align="center">
            </el-table-column>
            <el-table-column
              prop="productionlineName"
              label="产线" align="center">
            </el-table-column>
            <el-table-column
              prop="workshopName"
              label="车间" align="center">
            </el-table-column>
            <el-table-column
              prop="stateDelay"
              label="状态延时（s）" align="center">
            </el-table-column>
            <!--<el-table-column
              prop="val" align="center"
              label="设备类型">
            </el-table-column>-->
          </el-table>
        </div>
        <div style="position: absolute;bottom: 0;left: 30%">
          <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
                @parentMethod="searchPage"></Page>
        </div>
      </div>

    </div>

    <el-dialog
      v-loading="saveLoading"
      :title=$t('btn_15')
      :visible.sync="unDetailVisible" append-to-body
      width="500px"
      top="10%"
      :close-on-click-modal='false'
      :before-close="handleClose" custom-class="dialogBox">
      <div style="width: 450px; margin: 0 auto;">
        <div class="dialogMes2">
          <p>设备编号</p>
          <div class="mesInput">
            <el-input v-model="stationDataList.code"></el-input>
          </div>
        </div>
        <div class="dialogMes2">
          <p>设备名称</p>
          <div class="mesInput">
            <el-input v-model="stationDataList.name"></el-input>
          </div>
        </div>
        <div class="dialogMes2">
          <p>设备品牌</p>
          <div class="mesInput">
            <el-input v-model="stationDataList.brand"></el-input>
          </div>
        </div>
        <div class="dialogMes2">
          <p>设备型号</p>
          <div class="mesInput">
            <el-input v-model="stationDataList.model"></el-input>
          </div>
        </div>
        <div class="dialogMes2">
          <p>产线</p>
          <div class="mesInput">
            <el-select v-model="stationDataList.productionlineName" :placeholder="$t('input_65')">
              <el-option
                v-for="item in productionList"
                :key="item.value"
                :label="item.label"
                :value="item.label">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="dialogMes2">
          <p>车间</p>
          <div class="mesInput">
            <el-select v-model="stationDataList.workshopName" :placeholder="$t('input_65')">
              <el-option
                v-for="item in workList"
                :key="item.value"
                :label="item.label"
                :value="item.label">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="dialogMes2">
          <p>状态延时（s）</p>
          <div class="mesInput">
            <el-input v-model="stationDataList.stateDelay"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="chooseButton sendButton" @click="undetailSend"><i class="el-icon-s-promotion"></i>{{ $t('btn_13') }}</div>
	  </span>
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/css/map/map.css"
import Page from "@/components/common/page";
import StationPage from "@/assets/js/stationPage/stationPage.js";
import utils from '@/utils/utils'

export default {
  name: 'stationPage',
  components: {
    Page
  },
  data() {
    return {
      saveLoading: false,
      model: [],
      unDetailList: [],
      productionList: [{
        label: '一产线',
        value: '1'
      }],
      workList: [{
        label: '一车间',
        value: '1'
      }],
      pageNum: 1,
      inputValue: 0,
      pageSize: 10,
      pageCount: 0,
      unDetailVisible: false,
      unDeleteVisible: false,
      stationList: [{
        label: this.$t('label_272'),
        value: '0'
      }],
      searchDataList: {
        deviceName: '',
        deviceCode: ''
      },
      stationCodeList: [],
      MenuRoleList: [],
      stationDataList: {
        code: '',
        brand: '',
        model: '',
        productionlineName: '',
        workshopName: '',
        stateDelay: '',
        name: ''
      },
      excelName: "设备管理",
      sheet: [{
        title: "设备管理",
        tHeader: ["设备编号", "设备名称", "设备类型"],
        keys: ["code", "name", "val"],
        table: [],
        sheetName: "设备管理",
        cellStyle: [{
          cell: 'A1',
          font: {
            name: '黑体',
            sz: '18px'
          }
        }]
      }],
      tableData: [],
      content: [],
      tableInfo: {},
    }
  },
  methods: {
    handler() {

    },
    querySearchAsync(queryString, cb) {
      let param = {
        code: queryString
      }
      StationPage.getStationList(param).then((response) => {
        const data = response.data;
        console.log();
        if (data.code == "1") {
          cb(data.data)
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    handleSelect(item) {
      this.searchDataList.stationId = item.id;
      console.log(item);
    },
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    update() {
      if (Object.keys(this.tableInfo).length > 0) {
        this.unDetailVisible = true;
        this.stationDataList = this.tableInfo;
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    detailPop() {
      this.unDetailVisible = true
    },
    undetailSend() {
      this.saveLoading = true;
      StationPage.insert(this.tableInfo).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.search({
            pageNum: 1,
            pageSize: this.pageSize
          });
          this.unDetailVisible = false;
        }
        this.saveLoading = false;
      }).catch((response) => {
        console.log(response)
        this.saveLoading = false;
      })
    },
    handleClose() {
      this.unDetailList = [];
      this.unDetailVisible = false;
      this.unDeleteVisible = false;
    },
    searchPage(param) {
      var dataParam = this.searchDataList;
      var newParam = Object.assign(param, dataParam);
      this.pageNum = newParam.pageNum;
      this.pageSize = newParam.pageSize;
      this.$refs['pageModel'].setCurrent(this.pageNum);
      this.selectStationList(newParam);/*
		    this.selectStationAllList();*/
    },
    search() {
      let param = {
        pageNum: 1,
        pageSize: this.pageSize
      }
      this.searchPage(param);
      /*this.getStationList();*/
    },
    getStationList() {
      StationPage.stationList().then((response) => {
        const data = response.data;
        var termList = [];
        data.data.forEach(function (item, index) {
          const term = {
            id: Number(item.id),
            code: item.code
          };
          termList.push(term);
        });
        this.stationCodeList = termList;
      }).catch((response) => {
        console.log(response)
      })
    },
    selectStationList(param) {
      StationPage.selectStationList(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableData = data.data.records;
          this.pageCount = data.data.total;
          this.$refs['pageModel'].setCurrent(this.pageNum);
          this.pageSize = data.data.size;
          this.pageNum = data.data.current;
          this.$refs['pageModel'].setCurrent(this.pageNum);
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    selectContentList() {
      StationPage.selectContentList(1).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.content = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    selectStationAllList() {
      StationPage.selectStationAllList(this.searchDataList).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.sheet[0].table = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    handleCurrentChange(info) {
      this.tableInfo = info;
    }
  },
  created() {
    this.search();
    this.MenuRoleList = this.$store.getters.getMenu;/*
	  this.selectContentList();
	  this.selectStationAllList();*/
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/basic/stationPage.vue